import { logger as garnishLogger } from '@garnish/logger';

// ─── Logger ──────────────────────────────────────────────────────────────────

const log = garnishLogger.extend('ORDERING_MACHINE');
garnishLogger.enable('ORDERING_MACHINE');

export { log as orderingMachineLog };
